import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=67a50938&scoped=true&"
import script from "./Combobox.vue?vue&type=script&lang=ts&"
export * from "./Combobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a50938",
  null
  
)

export default component.exports